export const Roles  = [
    'Espionne',
    'Garde',
    'Prêtre',
    'Baron',
    'Servante',
    'Prince',
    'Chancelier',
    'Roi',
    'Comtesse',
    'Princesse'
]


export const Deck = [
    'Espionne',
    'Espionne',
    'Garde',
    'Garde',
    'Garde',
    'Garde',
    'Garde',
    'Garde',
    'Prêtre',
    'Prêtre',
    'Baron',
    'Baron',
    'Servante',
    'Servante',
    'Prince',
    'Prince',
    'Chancelier',
    'Chancelier',
    'Roi',
    'Comtesse',
    'Princesse'
]